if (!customElements.get('pdp-press')) {
  customElements.define(
    'pdp-press',
    class PdpPress extends HTMLElement {
      connectedCallback() {
        this.quotes = Array.from(this.querySelectorAll('[data-pdp-press-quote]'));
        this.buttons = Array.from(this.querySelectorAll('[data-pdp-press-logo]'));
        this.intervalMs = Math.max(5000, (Number(this.dataset.interval) || 7) * 1000);
        this.index = this.quotes.findIndex((quote) => quote.classList.contains('is-active'));
        if (this.index < 0) this.index = 0;
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index, true));
          button.addEventListener('keydown', (event) => this.onKey(event, index));
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });

        this.onVisibility = () => {
          if (document.hidden) this.stop();
          else this.start();
        };
        document.addEventListener('visibilitychange', this.onVisibility);

        this.select(this.index, false);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onKey(event, index) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const next = (index + delta + this.buttons.length) % this.buttons.length;
        this.buttons[next]?.focus();
        this.select(next, true);
      }

      select(index, resetTimer) {
        if (!this.quotes.length) return;
        this.index = (index + this.quotes.length) % this.quotes.length;

        this.quotes.forEach((quote, i) => {
          const active = i === this.index;
          quote.classList.toggle('is-active', active);
          quote.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.buttons.forEach((button, i) => {
          const active = i === this.index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
        });

        if (resetTimer) {
          this.stop();
          this.start();
        }
      }

      start() {
        this.stop();
        if (this.quotes.length < 2 || this.reducedMotion) return;
        this.timer = window.setInterval(() => this.select(this.index + 1, false), this.intervalMs);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}
